import { axios, base } from '../http';

export const getSchCourseScheduleConfigList = params => { return axios.get(`${base}/api/SchoolSchedule/GetSchCourseScheduleConfigList`, { params: params }).then(res => res.data); };

// ====== 新增：集体备课与教研后台管理 ======
// 获取教研组分页列表（后台）

export const getAdjustStatisticsList = params => { return axios.get(`${base}/api/CourseAdjustmentManage/GetStatisticsList`, { params: params }).then(res => res.data); };
// 代调课后台管理统- 导出

export const exportAdjustStatistics = params => { return axios.get(`${base}/api/CourseAdjustmentManage/ExportStatisticsList`, { params: params, responseType: 'blob' }).then(res => res); };
// 代调课后台管理统- 获取明细

export const getAdjustStatisticsDetails = params => { return axios.get(`${base}/api/CourseAdjustmentManage/GetStatisticsDetails`, { params: params }).then(res => res.data); };
// 代调课后台管理统- 扁平明细列表（统计页明细 Tab）

export const getAdjustStatisticsDetailList = params => { return axios.get(`${base}/api/CourseAdjustmentManage/GetStatisticsDetailList`, { params: params }).then(res => res.data); };

/** 管理端代调课申请记录（含待审批等全状态）。最后更新：2026-10-22 */
export const getAdjustApplicationRecords = params => { return axios.get(`${base}/api/CourseAdjustmentManage/GetApplicationRecords`, { params: params }).then(res => res.data); };

/** 管理端代调课申请记录导出。最后更新：2026-10-22 */
export const exportAdjustApplicationRecords = params => { return axios.get(`${base}/api/CourseAdjustmentManage/ExportApplicationRecords`, { params: params, responseType: 'blob' }).then(res => res); };
// 特殊课程代调课 - 管理端统计- 获取列表及汇

export const getSpecialAdjustStatisticsList = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/GetStatisticsList`, { params: params }).then(res => res.data); };
// 特殊课程代调课 - 管理端统计- 导出

export const exportSpecialAdjustStatistics = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/ExportStatisticsList`, { params: params, responseType: 'blob' }).then(res => res); };
// 特殊课程代调课 - 管理端统计- 获取明细（下钻弹窗，兼容旧入口）

export const getSpecialAdjustStatisticsDetails = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/GetStatisticsDetails`, { params: params }).then(res => res.data); };

/** 特殊课程代调课 - 扁平明细列表（明细 Tab）。最后更新：2026-10-22 */
export const getSpecialAdjustStatisticsDetailList = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/GetStatisticsDetailList`, { params: params }).then(res => res.data); };

/** 特殊课程代调课 - 申请记录。最后更新：2026-10-22 */
export const getSpecialAdjustApplicationRecords = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/GetApplicationRecords`, { params: params }).then(res => res.data); };

/** 特殊课程代调课 - 申请记录导出。最后更新：2026-10-22 */
export const exportSpecialAdjustApplicationRecords = params => { return axios.get(`${base}/api/SpecialCourseAdjustmentManage/ExportApplicationRecords`, { params: params, responseType: 'blob' }).then(res => res); };

export const getSysCourseListPage = (params) => {
  return axios.get(`${base}/api/SysCourse/get`, { params: params });
};

// 值周人员管理

export const GetSysCourseByDepartmentId = (params) => {
  return axios.get(`${base}/api/SysCourse/GetSysCourseByDepartmentId`, {
    params: params,
  });
};

//编辑教学科目管理

export const editSysCourse = (params) => {
  return axios.put(`${base}/api/SysCourse/put`, params);
};
//新增教学科目管理

export const addSysCourse = (params) => {
  return axios.post(`${base}/api/SysCourse/post`, params);
};
//删除教学科目管理

export const deleteSysCourse = (params) => {
  return axios.delete(`${base}/api/SysCourse/Delete`, { params: params });
};

//获取班级课程

export const getDeptCourseListPage = (params) => {
  return axios.get(`${base}/api/DeptCourse/get`, { params: params });
};
//获取班级调代课记�?

export const getAdjustmentList = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetAdjustmentList`, {
    params: params,
  });
};

/** 后台周课表（含日规则，鉴权） */
export const getWeekSchedule = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetWeekSchedule`, { params }).then(res => res.data);
};

/** H5 同口径班级周课表（weekDate 可选） */
export const getScheduleByClassId = (params) => {
  return axios.get(`${base}/api/Course/GetScheduleByClassId`, { params }).then(res => res.data);
};

/** 校区日期规则列表 */
export const getScheduleDayRuleList = (params) => {
  return axios.get(`${base}/api/ScheduleDayRule/GetList`, { params }).then(res => res.data);
};

/** 按班级周查询日规则 */
export const getScheduleDayRulesByClassWeek = (params) => {
  return axios.get(`${base}/api/ScheduleDayRule/GetByClassWeek`, { params }).then(res => res.data);
};

/** 批量保存校区日期规则 */
export const saveScheduleDayRuleRange = (params) => {
  return axios.post(`${base}/api/ScheduleDayRule/SaveRange`, params).then(res => res.data);
};

/** 删除校区日期规则 */
export const deleteScheduleDayRule = (params) => {
  return axios.delete(`${base}/api/ScheduleDayRule/Delete`, { params }).then(res => res.data);
};
//编辑班级课程

export const editDeptCourse = (params) => {
  return axios.put(`${base}/api/DeptCourse/put`, params);
};
//新增班级课程

export const addDeptCourse = (params) => {
  return axios.post(`${base}/api/DeptCourse/post`, params);
};
//删除班级课程

export const deleteDeptCourse = (params) => {
  return axios.delete(`${base}/api/DeptCourse/Delete`, { params: params });
};

export const batchAddDeptCourse = (params, schoolId) => {
  return axios.post(`${base}/api/DeptCourse/BatchAdd`, params, {
    params: { schoolId },
  });
};

/** 预览：将课表节次重绑到当前默认作息。创建于 2026-09-20 */
export const previewMigrateTimetableToDefaultSchedule = (params) => {
  return axios.post(`${base}/api/DeptCourse/PreviewMigrateTimetableToDefaultSchedule`, params);
};

/** 执行：将课表节次重绑到当前默认作息。创建于 2026-09-20 */
export const migrateTimetableToDefaultSchedule = (params) => {
  return axios.post(`${base}/api/DeptCourse/MigrateTimetableToDefaultSchedule`, params);
};

/** 导出班级课表矩阵数据（与导入 BatchAdd 同结构）。创建于 2026-09-20 */
export const exportTimetableMatrix = (params) => {
  return axios.post(`${base}/api/DeptCourse/ExportTimetableMatrix`, params);
};

//获取班牌终端管理

export const getCourseConfig = (params) => {
  return axios.get(`${base}/api/Department/GetCourseConfig`, { params: params });
};

//保存课程配置

export const saveCourseConfig = (params) => {
  return axios.post(`${base}/api/Department/SaveCourseConfig`, params);
};

/** 特殊课程考勤配置（不含班主任复核） */

export const getSpecialCourseConfig = (params) => {
  return axios.get(`${base}/api/Department/GetSpecialCourseConfig`, { params: params });
};

export const saveSpecialCourseConfig = (params) => {
  return axios.post(`${base}/api/Department/SaveSpecialCourseConfig`, params);
};

//编辑菜品

export const getSchedules = (params) => {
  return axios.get(`${base}/api/SchoolSchedule/GetSchedules`, {
    params: params,
  });
};

// 根据 Id 获取方案（含节次�?

export const getScheduleById = (params) => {
  return axios.get(`${base}/api/SchoolSchedule/GetScheduleById`, {
    params: params,
  });
};

// 新增方案

export const createSchedule = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/CreateSchedule`, params);
};

// 更新方案

export const updateSchedule = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/UpdateSchedule`, params);
};

// 删除方案（POST Body: { id: ... }�?

export const deleteSchedule = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/DeleteSchedule`, params);
};

// 新增节次

export const addPeriod = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/AddPeriod`, params);
};

// 更新节次

export const updatePeriod = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/UpdatePeriod`, params);
};

// 删除节次（POST Body: { id: ... }�?

export const deletePeriod = (params) => {
  return axios.post(`${base}/api/SchoolSchedule/DeletePeriod`, params);
};

// 按照班级获取节次信息

export const getScheduleByClass = (params) => {
  return axios.get(`${base}/api/SchoolSchedule/GetScheduleByClass`, {
    params: params,
  });
};

// 获取组织

export const getAttendanceStatsByClass = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetAttendanceStatsByClass`, {
    params: params,
  });
};

// 导出班级课程考勤统计
export const getAttendanceStatsByClassExport = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetAttendanceStatsByClassExport`, {
    params: params,
    responseType: "blob",
  });
};

// 课堂考勤迟到/早退扣分明细分页
export const getCourseAttendanceDutyDeductions = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetCourseAttendanceDutyDeductions`, {
    params: params,
  });
};

// 导出课堂考勤迟到/早退扣分明细
export const getCourseAttendanceDutyDeductionsExport = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetCourseAttendanceDutyDeductionsExport`, {
    params: params,
    responseType: "blob",
  });
};

// 日点名统计：总节次、已点名节次数、未点名节次明细（含科目、教师）

export const getMarkingStats = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetMarkingStats`, {
    params: params,
  });
};

// 教师维度点名汇总

export const getTeacherMarkingSummary = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherMarkingSummary`, {
    params: params,
  });
};

// 教师维度点名明细

export const getTeacherMarkingDetails = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherMarkingDetails`, {
    params: params,
  });
};

// 导出教师维度点名汇总

export const getTeacherMarkingSummaryExport = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherMarkingSummaryExport`, {
    params: params,
    responseType: "blob",
  });
};

// 教师课程签到汇总

export const getTeacherCourseCheckInSummary = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherCourseCheckInSummary`, {
    params: params,
  });
};

// 教师课程签到明细

export const getTeacherCourseCheckInDetails = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherCourseCheckInDetails`, {
    params: params,
  });
};

// 导出教师课程签到汇总

export const getTeacherCourseCheckInSummaryExport = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetTeacherCourseCheckInSummaryExport`, {
    params: params,
    responseType: "blob",
  });
};

// 根据上课记录获取点名动作列表

export const getRollCallActionsByRecord = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetRollCallActionsByRecord`, {
    params: params,
  });
};

// 根据部门ID 获取订餐明细

export const getMarkingStatsExport = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetMarkingStatsExport`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};
// 根据部门ID 获取学期周次

export const getDeptCourseStudentConfig = (params) => {
  return axios.get(`${base}/api/DeptCourse/GetStudentConfig`, { params: params });
};

// 保存自定义课程学生规�?

export const saveDeptCourseStudentConfig = (params) => {
  return axios.post(`${base}/api/DeptCourse/SaveStudentConfig`, params);
};

// 获取卡片挂失/解挂操作记录列表

export const getSpecialCourseTimeList = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetTimeList`, { params });
};

export const saveSpecialCourseTime = (data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/SaveTime`, data);
};

export const deleteSpecialCourseTime = (params) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/DeleteTime`, null, { params });
};

// 特殊课程班次

export const getSpecialCourseSessionList = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSessionList`, { params });
};

export const saveSpecialCourseSession = (data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/SaveSession`, data);
};

export const deleteSpecialCourseSession = (params) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/DeleteSession`, null, { params });
};
/** 批量删除班次，body 为 Id 数组 */

export const batchDeleteSpecialCourseSessions = (ids) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/BatchDeleteSessions`, ids);
};

// 班次默认教师

export const getSessionTeachers = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSessionTeachers`, { params });
};

export const saveSessionTeachers = (sessionId, data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/SaveSessionTeachers`, data, { params: { sessionId } });
};

// 周循环模板

export const getWeekTemplate = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetWeekTemplate`, { params });
};

export const saveWeekTemplate = (sessionId, data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/SaveWeekTemplate`, data, { params: { sessionId } });
};

export const applyWeekTemplate = (params) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/ApplyWeekTemplate`, null, { params });
};

// 每日排班

export const getScheduleList = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetScheduleList`, { params });
};
/** 特殊课程排班日历（按班级 / 按教师） */

export const getSpecialCourseScheduleCalendar = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSpecialCourseScheduleCalendar`, { params });
};
/** 与排班日历同筛选的代调课变动记录表 */

export const getSpecialCourseScheduleChangeLog = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSpecialCourseScheduleChangeLog`, { params });
};

export const saveDaySchedule = (sessionId, date, data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/SaveDaySchedule`, data, { params: { sessionId, date } });
};

export const deleteDaySchedule = (params) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/DeleteDaySchedule`, null, { params });
};

export const downloadScheduleTemplate = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/DownloadScheduleTemplate`, { params, responseType: "blob" });
};

export const importSchedule = (sessionId, overwrite, formData) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/ImportSchedule`, formData, {
    params: { sessionId, overwrite },
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const batchImportWeekTemplate = (departmentId, overwrite, formData) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/BatchImportWeekTemplate`, formData, {
    params: { departmentId, overwrite },
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const downloadBatchWeekTemplate = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/DownloadBatchWeekTemplate`, { params, responseType: "blob" });
};
/** 日历矩阵：多班次 × 日期范围内「每周一行、日～六列」，下载 / 批量导入（仅系统模板） */

export const downloadBatchMonthScheduleTemplate = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/DownloadBatchMonthScheduleTemplate`, { params, responseType: "blob" });
};

export const batchImportMonthSchedule = (departmentId, overwrite, formData) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/BatchImportMonthSchedule`, formData, {
    params: { departmentId, overwrite },
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const batchGenerateSessions = (departmentId, data) => {
  return axios.post(`${base}/api/SpecialCourseAdmin/BatchGenerateSessions?departmentId=${departmentId}`, data);
};

export const getSpecialCourseAttendanceStats = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSpecialCourseAttendanceStats`, { params });
};

export const getSpecialCourseAttendanceList = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetAttendanceList`, { params });
};

/** 班次某日点名履历（每次整班提交一条） */
export const getSpecialCourseMarkBatchHistory = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetMarkBatchHistory`, { params });
};

/** 某次点名相对上次的学生状态对比 */
export const getSpecialCourseMarkBatchStudentDiff = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetMarkBatchStudentDiff`, { params });
};

/** 导出特殊课程考勤统计 Excel（与列表筛选一致） */

export const exportSpecialCourseAttendanceStats = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/ExportSpecialCourseAttendanceStats`, {
    params,
    responseType: "blob",
  });
};
/** 教师特殊课程月到岗统计（管理端，与 H5 GetTeacherRollMonthStatistics 算法一致） */

export const getSpecialCourseTeacherRollMonthStats = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSpecialCourseTeacherRollMonthStats`, { params });
};
/** 教师月到岗统计 — 明细行（与汇总筛选一致） */

export const getSpecialCourseTeacherRollMonthStatDetails = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/GetSpecialCourseTeacherRollMonthStatDetails`, { params });
};
/** 导出教师月到岗统计 Excel */

export const exportSpecialCourseTeacherRollMonthStats = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/ExportSpecialCourseTeacherRollMonthStats`, {
    params,
    responseType: "blob",
  });
};
/** 导出教师月到岗明细 Excel（与明细接口筛选一致） */

export const exportSpecialCourseTeacherRollMonthStatDetails = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/ExportSpecialCourseTeacherRollMonthStatDetails`, {
    params,
    responseType: "blob",
  });
};
/** 导出指定班次某日考勤明细 Excel（全量） */

export const exportSpecialCourseAttendanceDetail = (params) => {
  return axios.get(`${base}/api/SpecialCourseAdmin/ExportAttendanceDetail`, {
    params,
    responseType: "blob",
  });
};

// ---- Communication 后台 ----
